import React, { useContext, lazy, Suspense } from "react";
import "./Project.scss";
import Button from "../../components/button/Button";
import { socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";

export default function Projects() {


  const repo = [
    {
      node:
      {
        description: "Urban Company is an Indian gig marketplace that offers home installation, maintenance and repair services, and home beauty and wellness services ",
        diskUsage: 7934,
        forkCount: 1,
        id: "MDEwOlJlcG9zaXRvcnkzNzUwNTM0ODk=",
        name: "Urban-Company",
        primaryLanguage: { name: "JavaScript", color: "#F1E05A" },
        stargazers: { totalCount: 1 },
        url: "https://github.com/AleemAlam/Urban-Company"
      }
    },
    {
      node: {
        description: "Goibibo is India’s leading online travel booking brand providing range of choice for hotels, flights, trains, bus and cars for travelers.",
        diskUsage: 4623,
        forkCount: 0,
        id: "MDEwOlJlcG9zaXRvcnkzODc4MzI4OTE=",
        name: "goibibo_clone",
        primaryLanguage: { name: "JavaScript", color: "#F1E05A" },
        stargazers: { totalCount: 1 },
        url: "https://github.com/Dee-Hegde/goibibo_clone"
      }
    },
    {
      node: {
        description: "Masai School Cohort - 13 | Unit 2 Project Week | Expedia.com clone",
        diskUsage: 1339,
        forkCount: 1,
        id: "MDEwOlJlcG9zaXRvcnkzNDU4OTM0NDY=",
        name: "expedia-clone",
        primaryLanguage: { name: "HTML", color: "#E34C26" },
        stargazers: { totalCount: 2 },
        url: "https://github.com/tambegaurav/expedia-clone"
      }
    },
    {
      node: {
        description: "Cloned Unsplash, a platform powered by an amazing community that has gifted hundreds of thousands of their own photos to fuel creativity worldwide.",
        diskUsage: 1372,
        forkCount: 0,
        id: "MDEwOlJlcG9zaXRvcnkzNTc1MDg5MzY=",
        name: "hexagon-Project",
        primaryLanguage: { name: "HTML", color: "#E34C26" },
        stargazers: { totalCount: 0 },
        url: "https://github.com/mohit512661/hexagon-Project"
      }
    },
    {
      node: {
        description: "Masai project 1",
        diskUsage: 345,
        forkCount: 0,
        id: "MDEwOlJlcG9zaXRvcnkzMzU1NjcxNDM=",
        name: "Project_1_engage",
        primaryLanguage: { name: "HTML", color: "#E34C26" },
        stargazers: { totalCount: 1 },
        url: "https://github.com/Darshan-Naik/Project_1_engage",
      }
    },
  ]

  const renderLoader = () => <Loading />;
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const { isDark } = useContext(StyleContext);

  return <Suspense fallback={renderLoader()}>
    <div className="main" id="opensource">
      <h1 className="project-title">Some other Projects</h1>
      <div className="repo-cards-div-main">
        {repo.map((v, i) => {
          return (
            <GithubRepoCard repo={v} key={v.node.id} isDark={isDark} />
          );
        })}
      </div>
      <Button
        text={"More Projects"}
        className="project-button"
        href={socialMediaLinks.github}
        newTab={true}
      />
    </div>
  </Suspense>
}